import { Form } from "react-bootstrap";

const FileInput = ({
  label,
  name,
  onChange,
  accept,
  required,
  fileName,
  isInvalid,
  feedback,
  ...rest
}) => {
  return (
    <Form.Group>
      <Form.Label htmlFor={name}>
        {label}
        {required && <i className="bx bxs-asterisk text-danger ms-1" />}
      </Form.Label>
      <div
        className={`d-flex align-items-center my-2 border ${
          isInvalid ? "border-danger" : "border-transparent"
        }`}
        style={{
          background: "#f5f5f5",
          height: "40px",
          borderRadius: "0.625rem",
          padding: "0px 6px",
          cursor: "pointer",
          transition: "border-color 0.2s ease",
        }}
        onClick={() => document.getElementById(name)?.click()}
      >
        <Form.Control
          type="file"
          id={name}
          name={name}
          className="d-none"
          onChange={onChange}
          accept={accept}
          required={required}
          {...rest}
        />
        <div
          className="bg-white me-3 mb-0 py-1 px-2"
          style={{
            borderRadius: "7px",
            fontWeight: 500,
            cursor: "pointer",
          }}
        >
          Choose file
        </div>
        <span
          className={`fw-medium text-truncate ${
            isInvalid ? "text-danger" : "text-muted"
          }`}
          style={{ maxWidth: "60%" }}
        >
          {fileName || "No file chosen"}
        </span>
      </div>

      {isInvalid && (
        <Form.Control.Feedback type="invalid" className="d-block">
          {feedback || `Please select a ${label.toLowerCase()}.`}
        </Form.Control.Feedback>
      )}
    </Form.Group>
  );
};

export default FileInput;
